"use client";

import { Box } from "@mui/material";
import { SxProps, Theme } from "@mui/material/styles";

export interface ImageBoxProps {
  src: string;
  alt: string;
  /**
   * Optional sx overrides for the underlying MUI Box.
   * You can use this to control width, height, hover effects, etc.
   */
  sx?: SxProps<Theme>;
  className?: string;
  onClick?: () => void;
}

export default function ImageBox({
  src,
  alt,
  sx,
  className,
  onClick,
}: ImageBoxProps) {
  return (
    <Box
      component="img"
      src={src}
      alt={alt}
      className={className}
      onClick={onClick}
      sx={{
        width: "100%",
        objectFit: "cover",
        borderRadius: 1,
        ...sx,
      }}
    />
  );
}


